export default "__VITE_ASSET__Cz57qujx__"